
import React, { useEffect, useRef } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Home from './Home';
import Documents from './components/Documents';
import { StaticMap } from './components/StaticMap';
import { Danish } from 'flatpickr/dist/l10n/da';
import * as flatpickr from 'flatpickr';
import IdleTimer from 'react-idle-timer';
import Login from './components/Login';
import SafetyInduction from './components/safetyinduction/SafetyInduction';
// import ExtraInteractiveStory from './components/safetyinduction/ExtraInteractiveStory';
import ShortInteractiveStory from './components/safetyinduction/ShortInteractiveStory';
import PauseScreen from './components/PauseScreen';
import Instructions from './components/Instructions/Instructions';
import { refreshFast, refreshSlow, refreshHourly } from './store/AppStore';



document.addEventListener('contextmenu', event => event.preventDefault());

Date.prototype.getWeek = function () { // eslint-disable-line no-extend-native
    var onejan = new Date(this.getFullYear(), 0, 1);
    return Math.ceil((((this - onejan) / 86400000) + onejan.getDay() + 1) / 7);
};

const App = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isPlaying = useSelector(state => state.storyState.playing);
    const currentStoryId = useSelector(state => state.storyState.currentStoryId);
    // Ref så intervallet altid bruger det nyeste story-id uden at effekten (og dermed al data-hentning) kører igen ved skift af story
    const currentStoryIdRef = useRef(currentStoryId);
    currentStoryIdRef.current = currentStoryId;
    const isPlayerPage = ['/', '/shortinteractivestory'].includes(window.location.pathname);

    useEffect(() => {
        flatpickr.default.localize(Danish);

        dispatch(refreshFast(currentStoryIdRef.current));
        dispatch(refreshSlow());
        dispatch(refreshHourly());

        const refreshInterval = setInterval(() => {
            dispatch(refreshFast(currentStoryIdRef.current));
        }, 1000 * 60 * 2);
        const slowRefreshInterval = setInterval(() => {
            dispatch(refreshSlow());
        }, 1000 * 60 * 15);
        const hourlyRefreshInterval = setInterval(() => {
            dispatch(refreshHourly());
        }, 1000 * 60 * 60);

        return () => {
            clearInterval(refreshInterval);
            clearInterval(slowRefreshInterval);
            clearInterval(hourlyRefreshInterval);
        };
    }, [dispatch]);

    const handleIdleAction = () => {
        navigate('/pausescreen');
    };

    return (
        <div>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/map" element={<StaticMap />} />
                <Route path="/login" element={<Login />} />
                <Route path="/safetyinduction" element={<SafetyInduction />} />
                {/* <Route path="/extrainteractivestory" element={<ExtraInteractiveStory />} /> */}
                <Route path="/shortinteractivestory" element={<ShortInteractiveStory />} />
                <Route path="/instructions" element={<Instructions />} />
                <Route path="/pausescreen" element={<PauseScreen />} />
            </Routes>
            {!(isPlayerPage && isPlaying) && (
                <IdleTimer
                    element={document}
                    onIdle={handleIdleAction}
                    timeout={1000 * 60 * 10}
                />
            )}
        </div>
    );
};

export default App;